module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lWeAE"))).then(() => parcelRequire('hEqeo'));